import { DocumentMeta } from 'bff'
import { formatInTimeZone } from 'date-fns-tz'
import { translate } from 'i11n'
import { DEFAULT_TIMEZONE } from 'piramid-constants'
import { Brandmark } from './Brandmark'

interface DocumentHeaderProps {
  meta: DocumentMeta
}

/**
 * Encabezado en flujo: aparece una sola vez, al principio del documento. La
 * numeración por página va por el `footerTemplate` de Chromium, no por acá.
 */
export const DocumentHeader = ({ meta }: DocumentHeaderProps) => (
  <header className='flex items-start justify-between gap-6 border-b border-zinc-200 pb-4'>
    <div className='flex flex-col gap-1'>
      <Brandmark branding={meta.branding} />
      <h1 className='text-[15pt] font-semibold leading-tight'>{meta.title}</h1>
    </div>

    <dl className='shrink-0 text-right text-[8pt] text-zinc-500'>
      <dt className='font-medium'>{translate('document.reference')}</dt>
      <dd className='mb-1 font-mono text-zinc-900'>{meta.reference}</dd>

      <dt className='font-medium'>{translate('document.generated_at')}</dt>
      <dd className='text-zinc-900'>
        {formatInTimeZone(
          new Date(meta.generated_at),
          DEFAULT_TIMEZONE,
          'dd/MM/yyyy HH:mm',
        )}
      </dd>
    </dl>
  </header>
)
